import * as XLSX from 'xlsx';


type BookType = 'csv' | 'xls' | 'xlsx';

const BOOKTYPE_EXTENSION_MAP: {[key: string]: BookType} = {
  csv: 'csv',
  biff8: 'xls',
  xlsx: 'xlsx',
};

function exportTable (json: any[], outputType: BookType, filename = 'export') {
  if (!BOOKTYPE_EXTENSION_MAP[outputType]) {
    outputType = 'csv';
  }

  const workbook = XLSX.utils.book_new();
  const sheet = XLSX.utils.json_to_sheet(json);
  XLSX.utils.book_append_sheet(workbook, sheet);

  const extension = BOOKTYPE_EXTENSION_MAP[outputType];
  XLSX.writeFile(workbook, `${filename}.${extension}`, {bookType: outputType});
}

export default exportTable;
